import {connect} from "pwa-helpers";
import {StofwareElement} from "@stofloos/core/base/sw-element";
import {store} from "@stofloos/stores/store";
import {initRequest, setPageLimit} from '@stofloos/actions/requests';
import {createObject, readObject, updateObject, deleteObject } from '@stofloos/actions/crud';
import {changePage, updateLocation} from "@stofloos/actions/app";
import {closeDialog} from "@stofloos/actions/dialog";

import { formToJSON, getFormElements, removeDefaultData } from "@stofloos/utils/sw-constants";
import assign from "lodash-es/assign";
import find from 'lodash-es/find';
import isEqual from "lodash-es/isEqual";

export class StofwareCrudSingle extends connect(store)(StofwareElement) {
	static get properties() {
		return {
			id: Number,
			identifier: { type: String },
			requestId: String,
			object: Object,
			endpoint: String,
			isLoading: { type: Boolean },
			single: { type: Boolean }
		};
	}

	constructor() {
		super();
		this.single = false;
	}

	stateChanged(state) {
		let current;
		if (this.identifier) {
			current = find(state.crud[this.requestId], [this.identifier, this.id]);
		} else {
			current = find(state.crud[this.requestId], ["id", parseInt(this.id)]);
		}
		if (this.active && state.crud[this.requestId] && this.object !== current) {
			this.object = current;
		}
	}

	copyObject() {
		let data = removeDefaultData(this.object);
		this.isLoading = true;
		store.dispatch(createObject(this.requestId, data))
			.then(() => {
				this.isLoading = false;
				store.dispatch(changePage("/" + this.endpoint));
				store.dispatch(updateLocation(window.location));
			})
			.error(() => {
				this.isLoading = false;
			});
	}

	createObject() {
		let formElements = getFormElements(this.shadowRoot.querySelector("sw-form, .sw-form"));
		let data = formToJSON(formElements);
		store.dispatch(createObject(this.requestId, data));
	}

	readObject() {
		this.isLoading = true;
		store
			.dispatch(readObject(this.requestId, this.id))
			.then(() => {
				this.isLoading = false;
			})
			.error(() => {
				store.dispatch(changePage("/" + this.endpoint));
				store.dispatch(updateLocation(window.location));
			});
	}

	updateObject() {
		let formElements = getFormElements(this.shadowRoot.querySelector("sw-form, .sw-form"));
		let data = formToJSON(formElements);

        // WHY THIS? Merge and remove undefined null values
        const merged = assign({}, this.object, data);
        store.dispatch(updateObject(this.requestId, merged, false, this.id));
    }

	deleteObject() {
		store.dispatch(deleteObject(this.requestId, this.id)).then(() => {
			store.dispatch(closeDialog("deleteObjectDialog"));
			store.dispatch(changePage("/" + this.endpoint));
			store.dispatch(updateLocation(window.location));
		});
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);

		this.requestId = this.endpoint;
		if(!store.getState().requests[this.requestId]){
			store.dispatch(initRequest(this.requestId, this.endpoint));
		}
	}
}
